export const PINNED = 'pinned';
export const WIDGET_PINNED = 'Виджет закреплен';
